var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.count > 0)?_c('v-avatar',{style:({ top: _vm.top, right: _vm.right }),attrs:{"size":_vm.measures.size,"color":"primary"}},[_c('span',{staticClass:"white--text",style:({ 'font-size': `${_vm.measures.fontSize}px !important` })},[_vm._v(" "+_vm._s(_vm.count)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }